import { useCallback, useMemo } from 'react';
import { useStatePiece } from 'react-pieceful-state';

const useSharedBoolean = (base: string, initial = false, region = 'editAsset') => {
  const [value, setValue] = useStatePiece<boolean>(base, initial, region);

  const setVal = useCallback((v) => setValue(() => v), []);
  const toggle = useCallback(() => setValue((v) => !v), []);
  const setTrue = useCallback(() => setValue(() => true), []);
  const setFalse = useCallback(() => setValue(() => false), []);

  return useMemo(() => [value, setVal, { setTrue, setFalse, toggle }] as const, [
    setFalse,
    setTrue,
    toggle,
    value,
    setVal,
  ]);
};

export default useSharedBoolean;
